export enum FeedbackType {
  INFO,
  ERROR,
}

export interface Feedback {
  type: FeedbackType
  message: string
}

let latest = undefined as Feedback | undefined
const listeners = [] as ((feedback: Feedback) => void)[]

export function addFeedback(message: string, type?: FeedbackType) {
  type = type || FeedbackType.INFO
  latest = { message, type }
  for (const listener of listeners) {
    listener(latest)
  }
}

export function addListener(func: (feedback: Feedback) => void) {
  listeners.push(func)
}

export function removeListener(func: (feedback: Feedback) => void) {
  const ix = listeners.indexOf(func)
  if (ix < 0) {
    throw new Error('Listener not found')
  }
  listeners.splice(ix, 1)
}
